import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>A caloric intake higher than allowed under Code B4155 is being prescribed. This system can only authorize 300 caloric units per month. You may need to complete a paper prior approval documenting medical necessity.</p>
				
				<p>You should have FORM eMedNY 361501 Order/Prior Approval Request. The prescriber should have filled out fields 1 through 17. You are required to fill out fields 18 through 31. Submit the form electronically through ePaces, OR MAIL TO: Computer Sciences Corporation, PO Box 4600, Rensselaer, NY 12144-4600.</p>
				
				<p>Form eMedNY 361501 can be ordered from Computer Sciences Corporation by calling 1/800-343-9000 in New York State, Or 518/447-9860 outside of New York State.</p>
				
				<div className="button" onClick={()=>this.props.navigate('D1A')}>View Medicaid Enteral Formula Coverage Criteria</div>
			</div>
		);	
	}
}